<template>
  <div>
    Display MaxxEditor Users Here...
  </div>
</template>

<script>
export default {
  name: 'MaxxEditorUsers',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
